export interface AdSlotConfig {
  id: string
  name: string
  page: string
  type: 'Banner' | 'Native' | 'Pinned' | 'Email' | 'Sticky'
  size: string
  basePrice: number
  status: 'active' | 'paused'
}

export interface AdPlacement {
  id: string
  slotId: string
  advertiser: string
  title: string
  description?: string
  ctaText: string
  imageUrl?: string
  linkUrl: string
  bgColor?: string
  accentColor?: string
  badge?: string
}

export const ALL_AD_SLOTS: AdSlotConfig[] = [
  {
    id: 'SLOT-02',
    name: 'Сайдбар каталога',
    page: 'Каталог астрологов',
    type: 'Banner',
    size: '300×600',
    basePrice: 20000,
    status: 'active',
  },
  {
    id: 'SLOT-03',
    name: 'Сайдбар статьи',
    page: 'Блог',
    type: 'Native',
    size: '300×250',
    basePrice: 12000,
    status: 'active',
  },
  {
    id: 'SLOT-04',
    name: 'Закреп в топе каталога',
    page: 'Каталог астрологов',
    type: 'Pinned',
    size: 'Карточка',
    basePrice: 15000,
    status: 'active',
  },
  {
    id: 'SLOT-09',
    name: 'Блог — баннер',
    page: 'Блог',
    type: 'Banner',
    size: '728×90',
    basePrice: 15000,
    status: 'active',
  },
  {
    id: 'SLOT-11',
    name: 'Лунный календарь — баннер',
    page: 'Лунный календарь',
    type: 'Banner',
    size: '728×90',
    basePrice: 14000,
    status: 'active',
  },
  {
    id: 'SLOT-12',
    name: 'Профиль астролога — рекомендации',
    page: 'Профиль астролога',
    type: 'Pinned',
    size: 'Карточка',
    basePrice: 10000,
    status: 'active',
  },
  {
    id: 'SLOT-13',
    name: 'Кросс-продажи на странице услуги',
    page: 'Детали услуги',
    type: 'Native',
    size: 'Карточка',
    basePrice: 16000,
    status: 'active',
  },
  {
    id: 'SLOT-16',
    name: 'Между карточками астрологов',
    page: 'Каталог астрологов',
    type: 'Native',
    size: 'Карточка',
    basePrice: 12000,
    status: 'active',
  },
  {
    id: 'SLOT-19',
    name: 'Маркетплейс — сайдбар',
    page: 'Маркетплейс',
    type: 'Banner',
    size: '300×600',
    basePrice: 18000,
    status: 'active',
  },
  {
    id: 'SLOT-20',
    name: 'Маркетплейс — между товарами',
    page: 'Маркетплейс',
    type: 'Native',
    size: 'Карточка',
    basePrice: 14000,
    status: 'active',
  },
  {
    id: 'SLOT-21',
    name: 'Статья — inline баннер',
    page: 'Блог (статья)',
    type: 'Native',
    size: '728×90',
    basePrice: 15000,
    status: 'active',
  },
  {
    id: 'SLOT-22',
    name: 'Астро-календарь — под CTA',
    page: 'Астро-календарь',
    type: 'Native',
    size: '728×90',
    basePrice: 16000,
    status: 'active',
  },
]

export const MOCK_ADS: Record<string, AdPlacement[]> = {
  'SLOT-03': [
    {
      id: 'ad-03-1',
      slotId: 'SLOT-03',
      advertiser: 'Astriqo',
      title: 'Хотите узнать больше о своей карте?',
      description:
        'Закажите полный натальный отчёт на 40+ страниц с детальным анализом всех аспектов вашей жизни.',
      ctaText: 'Заказать отчёт',
      linkUrl: '#',
      bgColor: 'bg-gradient-to-r from-indigo-50 to-violet-50',
      accentColor: 'bg-indigo-600',
    },
  ],
  'SLOT-02': [
    {
      id: 'ad-02-1',
      slotId: 'SLOT-02',
      advertiser: 'Astriqo',
      title: 'Курс профессиональной астрологии',
      description:
        'Станьте сертифицированным астрологом за 6 месяцев. Практика с первого дня.',
      ctaText: 'Узнать подробнее',
      linkUrl: '#',
      bgColor: 'bg-gradient-to-br from-indigo-500 to-purple-600',
      accentColor: 'bg-indigo-600',
    },
  ],
  'SLOT-04': [
    {
      id: 'ad-04-1',
      slotId: 'SLOT-04',
      advertiser: 'Мария Звёздная',
      title: 'Мария Звёздная',
      description: 'Топ-астролог. Специализация: финансы и карьера.',
      ctaText: 'Перейти в профиль',
      linkUrl: '#',
      badge: 'TOP',
    },
  ],
  'SLOT-11': [
    {
      id: 'ad-11-1',
      slotId: 'SLOT-11',
      advertiser: 'MoonPhase Inc.',
      title: 'Дневник лунных практик',
      description:
        'Физический блокнот для отслеживания состояний по лунному циклу.',
      ctaText: 'Заказать',
      linkUrl: '#',
      bgColor: 'bg-gradient-to-r from-slate-800 to-slate-900',
    },
  ],
  'SLOT-12': [
    {
      id: 'ad-12-1',
      slotId: 'SLOT-12',
      advertiser: 'Astriqo',
      title: 'Александр Ведов',
      description:
        'Вам также может подойти этот специалист. Схожий подход и методы.',
      ctaText: 'Смотреть профиль',
      linkUrl: '#',
    },
  ],
  'SLOT-13': [
    {
      id: 'ad-13-1',
      slotId: 'SLOT-13',
      advertiser: 'Astriqo',
      title: 'Консультация после отчета',
      description:
        'Остались вопросы после прочтения? Обсудите их с астрологом лично.',
      ctaText: 'Записаться',
      linkUrl: '#',
    },
  ],
  'SLOT-09': [
    {
      id: 'ad-09-1',
      slotId: 'SLOT-09',
      advertiser: 'Astriqo',
      title: 'Станьте астрологом',
      description:
        'Онлайн-курс профессиональной астрологии. Сертификат по окончании. Старт — каждый месяц.',
      ctaText: 'Записаться на курс',
      linkUrl: '#',
      bgColor: 'bg-gradient-to-br from-violet-500 to-indigo-600',
      accentColor: 'bg-violet-600',
    },
  ],
  'SLOT-16': [
    {
      id: 'ad-16-1',
      slotId: 'SLOT-16',
      advertiser: 'TarotMaster',
      title: 'Обучение картам Таро',
      description: 'Научитесь читать карты с нуля за 1 месяц. Онлайн-курс.',
      ctaText: 'Узнать больше',
      linkUrl: '#',
    },
  ],
  'SLOT-19': [
    {
      id: 'ad-19-1',
      slotId: 'SLOT-19',
      advertiser: 'Astriqo',
      title: 'Консультация с астрологом',
      description:
        'Живой разговор с проверенным специалистом. Ответы на ваши вопросы о карьере и отношениях.',
      ctaText: 'Выбрать астролога',
      linkUrl: '#',
      bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
      accentColor: 'bg-amber-600',
    },
  ],
  'SLOT-20': [
    {
      id: 'ad-20-1',
      slotId: 'SLOT-20',
      advertiser: 'Astriqo',
      title: 'Станьте сертифицированным астрологом',
      description: 'Профессиональный курс с практикой. Диплом по окончании.',
      ctaText: 'Узнать подробнее',
      linkUrl: '#',
    },
  ],
  'SLOT-21': [
    {
      id: 'ad-21-1',
      slotId: 'SLOT-21',
      advertiser: 'Astriqo',
      title: 'Прогноз на ваш персональный год',
      description:
        'Соляр (солнечное возвращение) — узнайте ключевые темы, возможности и вызовы ближайшего года.',
      ctaText: 'Узнать подробнее',
      linkUrl: '#',
      bgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
      accentColor: 'bg-emerald-600',
    },
  ],
  'SLOT-22': [
    {
      id: 'ad-22-1',
      slotId: 'SLOT-22',
      advertiser: 'Astriqo',
      title: 'Индивидуальный прогноз транзитов',
      description:
        'Узнайте, какие планетарные влияния ждут именно вас в ближайшие месяцы.',
      ctaText: 'Заказать прогноз',
      linkUrl: '#',
      bgColor: 'bg-gradient-to-r from-indigo-50 to-violet-50',
      accentColor: 'bg-indigo-600',
    },
  ],
}
